import { Flex, Avatar, Text, Center } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';
import { UsersRight } from '@kula-ai/icons-core';

export const CandidateReferredNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { candidate = {}, job_name, referred_date } = data;
  const { name: contact_name, id: contact_id } = candidate;

  return (
    <NotificationCard notification={notification}>
      <Flex alignItems="baseline" gap="6px">
        <Center minW="46px" h="46px" borderRadius="full" bg="ats-tertiary">
          <UsersRight size="1em" className="kula-icon" />
        </Center>
        <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
          <Text>
            <Text as="span" size="sm">
              Your referral of{' '}
            </Text>
            <Text as="span" size="sm-bold">
              <NotificationLink
                to={`/candidates/${contact_id}`}
                label={contact_name}
                onClose={onClose}
                notification={notification}
                data-test-id="candidate-link"
              />
            </Text>
            <Text as="span" size="sm">
              {` for the ${job_name} role has been
              submitted`}
            </Text>
          </Text>

          <Text size="sm-bold">Details</Text>
          <Flex
            border="1px solid"
            borderColor="border-color"
            borderRadius="sm"
            p="14px"
            flexDir="column"
            gap="6px"
            mt="-6px"
          >
            <Text size="sm-bold">Candidate</Text>
            <Flex mb="6px" gap="6px">
              <Avatar
                size="2xs"
                borderRadius="4px"
                className="avatar-xs"
                name={contact_name}
              />
              <Text size="sm">{contact_name}</Text>
            </Flex>
            <Text size="sm-bold">Job</Text>
            <Text size="sm" mb="6px">
              {job_name}
            </Text>
            <Text size="sm-bold">Referred on</Text>
            <Text size="sm" mb="6px">
              {referred_date}
            </Text>
          </Flex>
          <NotificationTime notification={notification} />
        </Flex>
      </Flex>
    </NotificationCard>
  );
};
